<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="1000"
      ref="formModel"
      fenlei
    >
      <tableForm
        slot="valueList"
        ref="valueList"
        :forms="valueListForms"
        :item1="valueListItem"
        v-model="item.valueList"
        height="400"
      >
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 110,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        keyword: "",
        model: "其他类",  
        name: '',
        value: "",
        remark: "",
        valueList: [],
      },
      valueListForms: [
        {
          title: "名称/name",
          key: "name",
          type: "Input",
          required: true,
        },
        {
          title: "编码/id",
          key: "id",
          type: "InputNumber",
          required: false,
        },
        {
          title: "键/key",
          key: "key",
          type: "Input",
          required: false,
        },
        {
          title: "值/val",
          key: "val",
          type: "Input",
          required: false,
        },
        {
          title: "标签/tag",
          key: "tag",
          type: "Input",
          required: false,
        },
      ],
      valueListItem: {
        name: "",
        id: 0,
        key: "",
        val: "",
        tag: "",
      },
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        model:'',
        //startTime: new Date(2023, 4, 1).getTime(),
        //endTime: new Date(2023, 6, 1).getTime(),
        keyword: '',
      },
      total: 0,
      forms: [
        {
          title: "名称",
          key: "name",
          required: true,
          type: "Input",
          span: 6,
        },
        {
          title: "主键",
          key: "keyword",
          required: false,
          type: "Input",
          span: 6,
        },
        {
          title: "类别",
          key: "model",
          required: false,
          type: "Select",
          selectItems:['其他类','费用类','订单类','车辆设备类'],
          span: 6,
        },

        {
          title: "备注",
          key: "remark",
          required: false,
          type: "Input",
          span: 6,
        },
        {
          title: "值",
          key: "valueList",
          slotForm: "valueList",
          required: true,
          noTable: true,
          hideLabel: true,
          span: 24,
        },
      ],
      searchForms: [
        {
          title: "字典分类",
          key: "model",
          type: "Select",
          selectItems:['其他类','费用类','订单类','车辆设备类'],
        },
        /* {
          title: "shijian",
          key: "start",
          key1: "end",
          type: "lyyymmdd",
          select:true,
          selectTypes:'obj',
          selectItemss:[{id:1,name:'222'},{id:2,name:'666'}],
          keys:'keyword',
          times:'1,2'
        }, */
      ],
    };
  },
  methods: {
    getList() {
      console.log(this.searchItem);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-dm/dictionary/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].valueList = this.utils.strToJson(data[i].value);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      
      var table=this.$refs.valueList.yanzheng();
      if (!table) {
        this.$Message.error('表格未填完')
        return;
      }
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      this.item.value = JSON.stringify(a.valueList);
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-common-server-dm/dictionary/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-common-server-dm/dictionary/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-common-server-dm/dictionary/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      console.log(this.item);
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 130,
      max: 400,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);

    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/system/dictionary.vue